<div class="page-wrapper"
     [elementHeight]="'app'">
    <!-- NOTE: page-wrapper class is required for modals to be created inside of it -->

    <!-- off canvas is on top, as it scrolls from the top -->
    <ng-container *afterContentInit>
        <page-off-canvas *ifSize="'MS'"
                         [toggleClass]="'_visible'"
                         [toggleClassBy]="offCanvasState"
                         [offCanvasState]="offCanvasState"></page-off-canvas>
    </ng-container>

    <app-busy-state></app-busy-state>

    <router-app-busy-state></router-app-busy-state>

    <div [elementHeight]="headerElementId"
         [elementHeightOptions]="{topOffset: true, local: false}">
        <page-header [offCanvasState]="offCanvasState"
                     class="z-2 pos-relative"
                     #pageHeader></page-header>
    </div>

    @if (hasHeader) {
    <div [class.page-content]="hasPageContentClass"
         class="z-1 pos-relative"
         [elementHeight]="'page-content'">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
    }

    <ng-container *afterContentInit="'router'">

        <!-- page footer -->
        <page-footer *ifNotCheckoutProcess
                     [elementHeight]="'page-footer-wrapper'"></page-footer>
    </ng-container>
</div>